import React, { FC } from 'react';
import { UserLocation } from 'src/api/types';
import { FormattedMessage } from 'react-intl';
import { useRouter } from 'next/router';
import Constraints from 'src/shared-components/Constraints/Constraints';

import NavigationLink from 'src/shared-components/NavigationLink/NavigationLink';
import useUserLocation from 'src/hooks/useUserLocation';
import trns from '../trns';

interface Props {
  citiesList?: UserLocation[];
  tradeName?: string;
  cityClickCallback?: (location: UserLocation) => void;
}

const ListOfCities: FC<Props> = ({
  citiesList = [],
  tradeName,
  cityClickCallback
}) => {
  const {
    query: { drug }
  } = useRouter();
  const userLocation = useUserLocation();

  if (!citiesList || !citiesList?.length) return null;

  const cities = citiesList.filter((city) => city?.name !== userLocation?.name);

  return (
    <Constraints className="!mb-20 w-[90%]">
      <h2 className="text-astronautBlue fs-header5-bold uppercase mb-9 px-5 xl:px-0">
        <FormattedMessage
          {...trns.buyVitaminsInOtherCities}
          values={{
            tradeName
          }}
        />
      </h2>
      <div className="flex row flex-wrap px-5 xl:px-0 -ml-3">
        {cities.map((city, index) => {
          return (
            <NavigationLink
              key={index}
              href={`/tradename/${drug}/${city?.translitName}`}
              passClassName="mt-3 ml-3 px-3 py-2 fs-body-bold border border-alto rounded-lg"
              onClick={() => cityClickCallback(city)}
              shallow
              scroll={true}
            >
              {city.name}
            </NavigationLink>
          );
        })}
      </div>
    </Constraints>
  );
};

export default ListOfCities;
